import {
  DATA_CONNECTOR_SUPABASE_ENVIRONMENT_VARIABLES_BEGIN,
  DATA_CONNECTOR_SUPABASE_ENVIRONMENT_VARIABLES_SUCCESS,
  DATA_CONNECTOR_SUPABASE_ENVIRONMENT_VARIABLES_FAILURE,
  DATA_CONNECTOR_SUPABASE_ENVIRONMENT_VARIABLES_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
export function supabaseEnvironmentVariables(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_SUPABASE_ENVIRONMENT_VARIABLES_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/external-datasource/environments/constants`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_SUPABASE_ENVIRONMENT_VARIABLES_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_SUPABASE_ENVIRONMENT_VARIABLES_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissSupabaseEnvironmentVariablesError() {
  return {
    type: DATA_CONNECTOR_SUPABASE_ENVIRONMENT_VARIABLES_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_SUPABASE_ENVIRONMENT_VARIABLES_BEGIN:
      return {
        ...state,
        supabaseEnvironmentVariablesPending: true,
        supabaseEnvironmentVariablesError: null,
      };

    case DATA_CONNECTOR_SUPABASE_ENVIRONMENT_VARIABLES_SUCCESS:
      return {
        ...state,
        supabaseEnvironmentVariablesPending: false,
        supabaseEnvironmentVariablesError: null,
      };

    case DATA_CONNECTOR_SUPABASE_ENVIRONMENT_VARIABLES_FAILURE:
      return {
        ...state,
        supabaseEnvironmentVariablesPending: false,
        supabaseEnvironmentVariablesError: action.data.error,
      };

    case DATA_CONNECTOR_SUPABASE_ENVIRONMENT_VARIABLES_DISMISS_ERROR:
      return {
        ...state,
        supabaseEnvironmentVariablesError: null,
      };

    default:
      return state;
  }
}
